import { SENTRY_DNS } from "@/config/enviroment";
import { isNativeDevice } from "@/utils/platform";

function getSentry() {
  if (isNativeDevice) {
    return require("@sentry/react-native");
  }
  return require("@sentry/react");
}

export function initializeLogger() {
  if (!__DEV__) {
    getSentry().init({
      dsn: SENTRY_DNS,
    });
  }
}

export const logger = {
  error: (error: Error | any, context?: any) => {
    if (__DEV__) {
      console.error(error);
    } else {
      getSentry().captureException(error, context);
    }
  },
};
